class SessionService {
  isAdminView;

  isAdmin;

  constructor() {
    this.fields = [
      'authVersion',
      'orgId',
      'isAdmin',
      'isOrgAdmin',
      'termsAccepted',
      'userId',
      'userName',
      'userRole',
      'accessList',
      'email',
      'firstName',
      'lastName',
      'accessToken',
      'refreshToken',
      'exp',
      'publisher_type',

      /*
       * Used to save user-selected params like date range or columns. e.g.
       * {date_from: '2019-03-23', date_to: '2019-04-06',
       *  article_columns: [], merchant_columns: [], ...}
       */
      'dashboardParams',
      'isAdminView', // Used to feature toggle while logged as admin
      'allSites', // Used to toggle multi-account view
      'allPubs', // Used for admin multi-account view
      'allAdminOrgs', // Used for admin multi-account view
      'merchPricingModel', // Used to hide Category/Brand bidding page from CPA merchants
    ];

    // Avoid console error before Session is populated
    this.accessList = [];
  }

  create(object) {
    this.fields.forEach(field => (this[field] = object[field]));
    window.localStorage.currentUser = JSON.stringify(this);
  }

  destroy() {
    this.fields.forEach(field => (this[field] = null));
    delete window.localStorage.currentUser;
  }

  update(object) {
    Object.keys(object).forEach(field => {
      if (this.fields.indexOf(field) >= 0) this[field] = object[field];
    });
    window.localStorage.currentUser = JSON.stringify(this);
  }

  getAccessListIds() {
    const role = this.isAdmin ? (this.allPubs ? 'publishers' : 'merchants') : this.userRole;
    const list = this.isAdmin ? this.allAdminOrgs : this.accessList;

    return list.reduce((agg, org) => {
      if (org.orgId !== this.orgId && org.type === role) {
        agg += `${!agg ? '' : ','}${org.orgId}`;
      }
      return agg;
    }, '');
  }
}

export const session = new SessionService();
